// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   ClosedMenuArrow,
//   OpenMenuArrow,
//   SettingsFillIcon,
//   SettingsIcon,
// } from "../assets/images/svg/svg";
// import { useSelector } from "react-redux";
// import { sidebarList } from "../Utils/CommonService";
// import { getOrganizationId, getOrganizationType } from "../Utils/CommonUtils";
// const Navdata = () => {
//   // const menuItems=[

//   //     {
//   //         icon: <SettingsIcon/>,
//   //         fillIcon:<SettingsFillIcon/>,
//   //         title: "Settings",
//   //         code: "SETTINGS",
//   //         path: "/settings/master/applications",
//   //         isSelected: false,
//   //         access_flag:1,
//   //         menus: [
//   //           {
//   //             iconOpened:<OpenMenuArrow/>,
//   //             iconClosed: <ClosedMenuArrow/>,
//   //             title: "Masters",
//   //             path: "/settings/master",
//   //             code: "SETT_MST",
//   //             access_flag:1,
//   //             menus: [
//   //               {
//   //                 title: "Applications",
//   //                 code: "SETT_MST_APP",
//   //                 path: "/settings/master/applications",
//   //                 access_flag:1
//   //               },
//   //             ],
//   //           },
//   //           {
//   //             iconOpened:<OpenMenuArrow/>,
//   //             iconClosed: <ClosedMenuArrow/>,
//   //             title: "User management",
//   //             path: "/settings/user_management",
//   //             code: "SETT_UMT",
//   //             access_flag:1,
//   //             menus: [
//   //               {
//   //                 title: "Roles",
//   //                 code: "SETT_UMT_ROL",
//   //                 path: "/settings/user_management/roles",
//   //                 access_flag:1
//   //               },
//   //               {
//   //                 title: "Users",
//   //                 code: "SETT_UMT_USR",
//   //                 path: "/settings/user_management/users",
//   //                 access_flag:1
//   //               },
//   //               {
//   //                 title: "Module Access",
//   //                 code: "SETT_UMT_MAS",
//   //                 path: "/settings/user_management/module_access",
//   //                 access_flag:1
//   //               },
//   //             ],
//   //           },
//   //           {
//   //             iconOpened:<OpenMenuArrow/>,
//   //             iconClosed: <ClosedMenuArrow/>,
//   //             title: "Utils",
//   //             path: "/settings/utils",
//   //             code: "SETT_UTL",
//   //             access_flag:1,
//   //             menus: [
//   //               {
//   //                 title: "Service Provider",
//   //                 code: "SETT_UTL_SP",
//   //                 path: "/settings/utils/service_provider",
//   //                 access_flag:1
//   //               },
//   //             ],
//   //           },
//   //         ],
//   //       },
//   // ]
//   const menuItems = useSelector((state) => state.sidebar);
//   // const organizationType = useSelector(
//   //   (state) => state.common.user.organizationType
//   // );
//   // const organizationId = useSelector(
//   //   (state) => state.common.user.information
//   // );
//   const { organizationType } = getOrganizationType();
//   const { orgId, } = getOrganizationId();
//   useEffect(() => {
//     // if (organizationType) {
//     sidebarList(organizationType, orgId);
//     // }
//   }, []);
//   return <React.Fragment>{menuItems}</React.Fragment>;
// };
// export default Navdata;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ClosedMenuArrow,
  OpenMenuArrow,
  SettingsFillIcon,
  SettingsIcon,
} from "../assets/images/svg/svg";
import { useSelector, useDispatch } from "react-redux";
import { getUserInfo, sidebarList } from "../Utils/CommonService";
import { setOrgId, setOrganizationType } from "../slices/common/reducer";
import { getOrgId, getOrgType } from "../Utils/CommonUtils";

const Navdata = () => {
  const dispatch = useDispatch();
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationType = getOrgType();
  // const organizationId = getOrgId();

  useEffect(() => {
    getUserInfo()
  }, []);

  useEffect(() => {
    if (selectedUser.organizationid) {
      sidebarList(selectedUser.organizationid);
    }
  }, [selectedUser.organizationid]);

  const menuItems = useSelector((state) => state.sidebar);

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
